var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_5020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 83C64.9198 83 83.5 64.4198 83.5 41.5C83.5 18.5802 64.9198 0 42 0C19.0802 0 0.5 18.5802 0.5 41.5C0.5 64.4198 19.0802 83 42 83Z",
    fill: "url(#paint0_linear_568_5020)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8346 14.2284L18.8657 31.0461V58.3357C18.8657 60.3833 20.5256 62.0431 22.5732 62.0431H61.595C63.6426 62.0431 65.3024 60.3833 65.3024 58.3357V31.0461L44.4833 14.236C43.1279 13.1416 41.1935 13.1385 39.8346 14.2284Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5664,
    y: 19.6151,
    width: 33.1914,
    height: 41.1802,
    rx: 4.44897,
    fill: "url(#paint1_linear_568_5020)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4224 25.8237C28.4224 25.3517 28.8063 24.969 29.28 24.969H54.2482C54.7219 24.969 55.1058 25.3517 55.1058 25.8237C55.1058 26.2958 54.7219 26.6785 54.2482 26.6785H29.28C28.8063 26.6785 28.4224 26.2958 28.4224 25.8237Z",
    fill: "#4F6FFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4224 31.3795C28.4224 30.9075 28.8063 30.5248 29.28 30.5248H54.2482C54.7219 30.5248 55.1058 30.9075 55.1058 31.3795C55.1058 31.8516 54.7219 32.2342 54.2482 32.2342H29.28C28.8063 32.2342 28.4224 31.8516 28.4224 31.3795Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4224 36.9354C28.4224 36.4634 28.8063 36.0807 29.28 36.0807H54.2482C54.7219 36.0807 55.1058 36.4634 55.1058 36.9354C55.1058 37.4075 54.7219 37.7902 54.2482 37.7902H29.28C28.8063 37.7902 28.4224 37.4075 28.4224 36.9354Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4224 42.4911C28.4224 42.019 28.8063 41.6364 29.28 41.6364H54.2482C54.7219 41.6364 55.1058 42.019 55.1058 42.4911C55.1058 42.9631 54.7219 43.3458 54.2482 43.3458H29.28C28.8063 43.3458 28.4224 42.9631 28.4224 42.4911Z",
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8657 31.0021V58.3358C18.8657 60.3833 20.5256 62.0432 22.5732 62.0432H50.8908C54.5011 62.0432 55.9818 57.4077 53.04 55.3148L18.8657 31.0021Z",
    fill: "url(#paint2_linear_568_5020)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3027 31.0021V58.3358C65.3027 60.3833 63.6428 62.0432 61.5953 62.0432H22.8723L65.3027 31.0021Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.39 31.4043L24.4729 62.0432H22.7651L64.8869 30.7137L65.39 31.4043Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1031 67.5248C60.8029 67.5248 63.3119 66.7081 65.3967 65.3083L73.9275 73.4519L77.0214 69.8622L68.7895 62.0041C70.3098 59.8645 71.2037 57.2487 71.2037 54.4241C71.2037 47.1888 65.3384 41.3235 58.1031 41.3235C50.8678 41.3235 45.0024 47.1888 45.0024 54.4241C45.0024 61.6594 50.8678 67.5248 58.1031 67.5248ZM69.2766 54.424C69.2766 60.5494 64.311 65.5151 58.1855 65.5151C52.06 65.5151 47.0943 60.5494 47.0943 54.424C47.0943 48.2985 52.06 43.3328 58.1855 43.3328C64.311 43.3328 69.2766 48.2985 69.2766 54.424Z",
    fill: "#4F6FFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_568_5020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1845 65.7298C64.4937 65.7298 69.6083 60.6622 69.6083 54.4109C69.6083 48.1596 64.4937 43.0919 58.1845 43.0919C51.8753 43.0919 46.7607 48.1596 46.7607 54.4109C46.7607 60.6622 51.8753 65.7298 58.1845 65.7298Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.9268 73.4523L77.0206 69.8626L77.4867 70.3075C77.9388 70.7391 78.2095 71.3421 78.2392 71.9837C78.2689 72.6254 78.0552 73.2532 77.6451 73.729C77.235 74.2048 76.662 74.4897 76.0523 74.521C75.4426 74.5523 74.8461 74.3274 74.3939 73.8958L73.9279 73.4509L73.9268 73.4523Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_568_5020",
    x: 43.9352,
    y: 40.2664,
    width: 28.4987,
    height: 28.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.41277
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_568_5020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_568_5020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568_5020",
    x1: 30.6979,
    y1: 3.02039e-7,
    x2: 42.5302,
    y2: 132.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_568_5020",
    x1: 42.1621,
    y1: 19.6151,
    x2: 42.1621,
    y2: 60.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_568_5020",
    x1: 18.8657,
    y1: 30.9523,
    x2: 50.6923,
    y2: 66.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_5020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEmail);
export default __webpack_public_path__ + "static/media/preview-email.14a4c0ad2ceea5df66b59f25ca9b6f7d.svg";
export { ForwardRef as ReactComponent };